export default __webpack_public_path__ + "static/media/element_7.4c2c64d3.jpg";